import { arrayOf, string, func } from 'prop-types';
import React, { PureComponent } from 'react';
import { View } from 'react-native';

import { FORMS, SHAPES } from 'common';
import { THEME } from 'reactor/common';
import { Button, Form, Text } from 'reactor/components';
import styles from './Prices.style';

const { COLOR } = THEME;

class Prices extends PureComponent {
  static propTypes = {
    onChange: func,
    onValid: func,
    title: string,
    value: arrayOf(SHAPES.PRICE),
  };

  static defaultProps = {
    title: undefined,
    onChange: undefined,
    onValid() {},
    value: [],
  };

  render() {
    const {
      props: { title, value, ...inherit },
    } = this;

    return (
      <View style={[styles.container, inherit.style]}>
        { title && <Text level={2} lighten>{title}</Text> }
        <View style={styles.form}>
          <Form attributes={FORMS.PRICE} />
          <Button color={COLOR.PRIMARY} small title="Save" />
        </View>
      </View>
    );
  }
}

export default Prices;
